import React, { Component } from 'react' // eslint-disable-line
import { Observable, EmptyError, NEVER, merge } from 'rxjs'
import { takeUntil, throttleTime, map, takeWhile } from 'rxjs/operators'
import autobind from 'autobind-decorator'
import { isArray, isEqual } from 'libraries/lodash'
import { getTouchEventCoordinates } from 'front-end-core/helpers/document'
import { TouchMove, TouchEnd } from 'front-end-core/services/WindowService'
import { getMinimumSwipeThreshold } from 'services/WindowService'
import debug from 'front-end-core/core/debug'

const logError = (e) => {
  if (!(e instanceof EmptyError)) {
    debug.error(e)
  }
  return NEVER
}

// LEGACY Component - because inheritance sucks vs composition

// "At Facebook we haven’t found any use cases where we would recommend creating component inheritance hierarchies."
// https://reactjs.org/docs/composition-vs-inheritance.html

// TODO: Delete once useBaseState hook has been tested and has been in production for a period of time

@autobind
class BaseComponent extends Component {
  constructor (props, stateSource = null, initialState = {}) {
    super(props)

    if (isArray(stateSource)) {
      stateSource = merge(...stateSource)
    }

    Object.assign(this, {
      state: initialState,
      _isReady: false,
      _block: false
    })

    if (stateSource instanceof Observable) {
      this._subscription = stateSource
        .catch(logError)
        .subscribe(s => {
          if (this._isReady) {
            this.setState({ ...s })
          } else {
            Object.assign(this, { state: { ...this.state, ...s } })
          }
        })
    }
  }

  shouldComponentUpdate (props, state, context) {
    return !isEqual(props, this.props) || !isEqual(state, this.state) || !isEqual(context, this.context)
  }

  componentWillUnmount () {
    this._subscription && this._subscription.unsubscribe()
  }

  componentDidMount () {
    this._isReady = true
  }

  handleTouchStart (event) {
    const windowWidth = document.body.clientWidth
    let { x, y } = getTouchEventCoordinates(event.nativeEvent)
    const abs = Math.abs
    let continueSwipe

    TouchMove.pipe(
      takeUntil(TouchEnd),
      throttleTime(10),
      map(getTouchEventCoordinates),
      takeWhile(coords => continueSwipe !== false && (abs(coords.y - y) < abs(coords.x - x) || abs(coords.y - y) < 20))
    )
      .subscribe(end => {
        const swiped = Math.floor((abs(end.x - x) / windowWidth) * 100)
        if (swiped >= getMinimumSwipeThreshold(windowWidth)) {
          if (end.x - x < 0 && typeof this.handleSwipeLeft === 'function') {
            continueSwipe = this.handleSwipeLeft()
          }
          if (end.x - x > 0 && typeof this.handleSwipeRight === 'function') {
            continueSwipe = this.handleSwipeRight()
          }
          x = end.x
          y = end.y
        }
      })
  }
}

export default BaseComponent
